// @ts-nocheck
import { DatePicker } from "@shared/antd/date-picker";
import React, { Component } from "react";
import { DatePickerProps } from "antd/lib/date-picker/interface";
import { DEFAULT_DATE_PATTERN } from "../../util/Date/Date";

interface DefaultDatePickerProps extends DatePickerProps {
}

class DefaultDatePicker extends Component<DefaultDatePickerProps> {
  render() {
    return (
      <DatePicker format={this.props.showTime ? "DD.MM.YYYY HH:mm:ss" : DEFAULT_DATE_PATTERN} {...this.props} />
    );
  }
}

export default DefaultDatePicker;
